import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { useVehicles } from '../contexts/VehiclesContext';
export function SearchBar({
  size = 'lg',
  showSuggestions = true
}: {
  size?: 'lg' | 'md';
  showSuggestions?: boolean;
}) {
  const {
    marcas,
    modelos
  } = useVehicles();
  const [term, setTerm] = useState('');
  const navigate = useNavigate();
  const suggestions = Array.from(new Set([...marcas, ...modelos])).slice(0, 8);
  const go = (value: string) => {
    const q = value.trim();
    navigate(q ? `/catalogo?q=${encodeURIComponent(q)}` : '/catalogo');
  };
  return <div className="w-full" data-id="element-559" data-mp="3vx9dt9q01wuy">
      <form role="search" onSubmit={e => {
      e.preventDefault();
      go(term);
    }} className={`flex flex-col gap-2 rounded-2xl border border-line bg-surface2/80 p-2 backdrop-blur-xl sm:flex-row sm:items-center ${size === 'lg' ? 'shadow-glow' : ''}`} data-id="element-560" data-mp="3vxisi15lghlc">
        <label htmlFor="vcars-search" className="sr-only" data-id="element-561" data-mp="1qhalyzhy1tft">
          Buscá por marca, modelo o versión
        </label>
        <div className="flex flex-1 items-center gap-3 px-3" data-id="element-562" data-mp="1mdmeegtbaxuk">
          <SearchIcon className="h-5 w-5 shrink-0 text-neon" aria-hidden="true" data-id="element-563" data-mp="1hgvypulf649o" />
          <input id="vcars-search" type="search" value={term} onChange={e => setTerm(e.target.value)} placeholder="Buscá por marca, modelo o versión" className={`w-full bg-transparent text-white placeholder:text-mist/80 focus:outline-none ${size === 'lg' ? 'h-12 text-base' : 'h-10 text-sm'}`} data-id="element-564" data-mp="1ch9kbhtuuhza" />
        </div>
        <Button type="submit" size={size === 'lg' ? 'lg' : 'md'} className="sm:w-auto" data-id="element-565" data-mp="1vekmpbas9riy">
          Buscar vehículos
        </Button>
      </form>

      {showSuggestions ? <div className="mt-3 flex flex-wrap items-center gap-2" data-id="element-566" data-mp="2o3ri41exy0zz">
          <span className="text-[12px] font-semibold uppercase tracking-wide text-mist" data-id="element-567" data-mp="2o26pwig3mu5a">
            Búsquedas frecuentes
          </span>
          {suggestions.map(s => <button key={s} type="button" onClick={() => go(s)} className="rounded-full border border-line bg-surface2/60 px-3 py-1 text-[12.5px] text-mist transition-colors duration-150 ease-smooth hover:border-neon/60 hover:text-white" data-id="element-568" data-mp="q7t5qakcqwrh">
              {s}
            </button>)}
        </div> : null}
    </div>;
}